import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { LoanHero } from "@/components/loans/LoanHero";
import { LoanLenders } from "@/components/loans/LoanLenders";
import { LoanComparison } from "@/components/loans/LoanComparison";
import { LoanLeadForm } from "@/components/loans/LoanLeadForm";
import { LoanDocuments } from "@/components/loans/LoanDocuments";
import { LoanPlanning } from "@/components/loans/LoanPlanning";
import { LoanFaq } from "@/components/loans/LoanFaq";
import "@/education-loan.css";

const SECTIONS = [["loan-types", "Loan types"], ["loan-lenders", "Lenders"], ["loan-documents", "Documents"], ["loan-enquiry", "Enquire now"]];
export default function EducationLoan() {
  const { hash } = useLocation();
  const [profile, updateProfile] = useState({ study_level: "bachelors", co_borrower: "salaried", loan_type: "not_sure" });
  const setProfile = (key, value) => updateProfile((current) => {
    const next = { ...current, [key]: value };
    if (next.study_level === "bachelors" && next.co_borrower === "farmer") next.co_borrower = "salaried";
    return next;
  });
  useEffect(() => {
    const target = hash ? document.getElementById(hash.slice(1)) : null;
    if (target) target.scrollIntoView({ behavior: "instant", block: "start" });
    else window.scrollTo({ top: 0, behavior: "instant" });
  }, [hash]);
  useEffect(() => {
    const oldTitle = document.title;
    const meta = document.querySelector('meta[name="description"]');
    const oldDescription = meta?.content;
    document.title = "Education Loans up to ₹1.5 Cr* | Secured & Unsecured — EDUBRIDGE";
    if (meta) meta.content = "Explore secured and unsecured education loans, lender options and bachelor's/postgraduate document checklists. Loans up to ₹1.5 Cr subject to eligibility and lender approval. Enquire with Edubridge.";
    return () => { document.title = oldTitle; if (meta) meta.content = oldDescription; };
  }, []);
  return (
    <div className="education-loan-page min-h-screen bg-ink text-frost" data-testid="education-loan-page">
      <Nav />
      <main>
        <LoanHero />
        <nav className="loan-section-nav" aria-label="Education loan page sections" data-testid="loan-section-nav"><div className="container-x">{SECTIONS.map(([id, label]) => <a key={id} href={`#${id}`} data-testid={`loan-section-link-${id}`}>{label}</a>)}</div></nav>
        <LoanLenders />
        <LoanComparison onSelect={(value) => setProfile("loan_type", value)} />
        <LoanLeadForm profile={profile} setProfile={setProfile} />
        <LoanDocuments profile={profile} setProfile={setProfile} />
        <LoanPlanning />
        <LoanFaq />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}